import React from 'react'
import { Row, Col } from 'react-bootstrap'
import Icon from './icon'
import AddPhotoModal from './addPhotoModal'
import { PhotoSwipe } from 'react-photoswipe'

class PhotoGallery extends React.Component {
  static propTypes = {
    editable: React.PropTypes.bool,
    photos: React.PropTypes.object.isRequired,
    property: React.PropTypes.object.isRequired,
    onChange: React.PropTypes.func.isRequired
  }

  static contextTypes = {
    store: React.PropTypes.object,
    notify: React.PropTypes.func
  }

  constructor(props, context) {
    super(props, context)
    this.state = {
      isPhotoSwipeOpen: false,
      isAddModalOpen: false,
      activePhotoIdx: 0
    }
  }

  componentWillReceiveProps (props) {
    this.state = {
      isPhotoSwipeOpen: false,
      isAddModalOpen: false,
      activePhotoIdx: 0
    }
  }

  handlePhotoSwipeOpen (idx, evt) {
    evt.preventDefault()
    this.setState({
      isPhotoSwipeOpen: true,
      activePhotoIdx: idx
    })
  }

  handlePhotoSwipeClose () {
    this.setState({ isPhotoSwipeOpen: false })
  }

  async share (photo, idx, evt) {
    evt.preventDefault()
    evt.stopPropagation()
    const { property, onChange, photos } = this.props
    const { store, notify } = this.context
    const id = property.get('id')
    const photoId = photo.get('id')

    try {
      const sharedPhoto = await store.post(`/properties/${id}/photos/${photoId}/share`)
      onChange(photos.set(idx, sharedPhoto))
      notify('Photo shared')
    }
    catch (er) {
      console.error(er)
      notify(er.response.body.error)
    }
  }


  async markPrimary (photo, idx, evt) {
    evt.preventDefault()
    evt.stopPropagation()
    const { property, onChange, photos } = this.props
    const { store, notify } = this.context
    const updatedPhoto = photo.set('isPrimary', true)

    try {
      await store.post(`/properties/${property.get('id')}/photos/${photo.get('id')}`, updatedPhoto)
      onChange(photos.map((photo, pidx) => photo.set('isPrimary', idx === pidx)))
    }
    catch (er) {
      console.error(er)
      notify(er.response.body.error)
    }
  }

  async remove (photo, idx, evt) {
    evt.preventDefault()
    evt.stopPropagation()
    const { property, photos, onChange } = this.props
    const { store, notify } = this.context

    try {
      await store.delete(`/properties/${property.get('id')}/photos/${photo.get('id')}`)
      onChange(photos.filter((photo, pidx) => idx !== pidx))
    }
    catch (er) {
      console.error(er)
      notify(er.response.body.error)
    }
  }

  handleAddPhotoOpen () {
    this.setState({ isAddModalOpen: true })
  }

  handleAddPhotoChange (photo) {
    const { photos, onChange } = this.props
    onChange(photos.push(photo))
  }

  handleAddPhotoHide () {
    this.setState({ isAddModalOpen: false })
  }

  renderPhotoActions (photo, idx) {
    const { editable, property } = this.props
    const buttons = []

    if (editable && !photo.get('isPrimary')) {
      buttons.push((
        <a key={0}
          className="btn mark"
          title="Mark as primary"
          onClick={this.markPrimary.bind(this, photo, idx)}>
          <Icon name="fa-check" />
        </a>
      ))
    }
    if (editable) {
      buttons.push((
        <a key={1}
          className="btn remove"
          title="Remove"
          onClick={this.remove.bind(this, photo, idx)}>
          <Icon name="fa-trash" />
        </a>
      ))
    }
    if (property.get('isPrivate') && !photo.has('shareId')) {
      buttons.push((
        <a key={2}
          className="btn share"
          title="Share"
          onClick={this.share.bind(this, photo, idx)}>
          <Icon name="fa-share-square-o" />
        </a>
      ))
    }
    return buttons
  }

  renderAddPhoto () {
    const { editable, property } = this.props
    const { isAddModalOpen } = this.state
    if (!editable) return null

    return (
      <Col xs={3}>
        <div className="photo-add" onClick={::this.handleAddPhotoOpen}>
          <div className="add-icon text-center">
            <Icon name="fa-plus-circle" />
            <br/>
            Add new image
          </div>
        </div>
        <AddPhotoModal
          show={isAddModalOpen}
          property={property}
          onChange={::this.handleAddPhotoChange}
          onHide={::this.handleAddPhotoHide} />
      </Col>
    )
  }

  render () {
    const { photos } = this.props
    const { isPhotoSwipeOpen, activePhotoIdx } = this.state

    const options = {
      index: activePhotoIdx,
      shareEl: false
    }

    const items = photos.map(p => {
      const photoUrl = `${p.get('link')}`

      const img = global.Image ? new Image() : {}
      img.src = photoUrl

      return {
        src: photoUrl,
        w: img.naturalWidth,
        h: img.naturalHeight,
        title: p.get('description')
      }
    }).toJS()

    return (
      <div>
        <Row>
          <div className="redi-component-photo-img-gallery">
            {photos.map((photo, idx) => (
              <Col xs={3} key={idx}>
                <div
                  className="photo"
                  style={{ backgroundImage: `url(${photo.get('link')})` }}
                  onClick={this.handlePhotoSwipeOpen.bind(this, idx)}>
                  {this.renderPhotoActions(photo, idx)}
                </div>
              </Col>
            ))}
            {this.renderAddPhoto()}
          </div>
        </Row>

        <PhotoSwipe
          isOpen={isPhotoSwipeOpen}
          items={items}
          options={options}
          onClose={::this.handlePhotoSwipeClose}
        />
      </div>
    )
  }
}

export default PhotoGallery



// WEBPACK FOOTER //
// ./modules/shared/components/photoGallery.js